import { render, staticRenderFns } from "./KaijuAddFundsModal.vue?vue&type=template&id=57039a3a&"
import script from "./KaijuAddFundsModal.vue?vue&type=script&lang=ts&"
export * from "./KaijuAddFundsModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports